module.exports = __webpack_public_path__ + "static/app-store-icon-2d9f892caf31bfa159c93537c405ec7c.png";